// eslint-disable-next-line max-classes-per-file
import { CorporateDisCountPresenter } from "../corporate/corporateServiceInterfaces/corporateInterface";

export interface Root {
  status: boolean;
  message: any;
  data: EventPreAllocateDataInterface;
}

export interface EventPreAllocateDataInterface
  extends CorporateDisCountPresenter {
  name: string;
  image: string;
  date: string;
  time: string;
  eventId: string | number;
  eventName: string;
  eventSlug: string;
  categoryName: string;
  categorySlug: string;
  subCategoryName: string;
  subCategorySlug: string;
  location: string;
  cityName: string;
  citySlug: string;
  countryName: string;
  countrySlug: string;
  deliveryDescription: string;
  seatingDescription: string;
  hospitalityDescription: string;
  meetingPoint: any;
  freeCancellation: boolean;
  cancellationPolicy: any;
  thinksToKnow: string[];
  warrantyContent: string[];
  minPax: number;
  maxPax: number;
  totalAmount: number;
  totalPrice: number;
  totalPax: TotalPax[];
  currency: string;
  wholesaleCode: number;
  keySearchTimeExpire: number;
  expired: string;
  instantConfirm: boolean;
}
export class EventPreAllocateDataPresenter extends CorporateDisCountPresenter {
  name: string;

  image: string;

  date: string;

  time: string;

  eventId: string | number;

  eventName: string;

  eventSlug: string;

  categoryName: string;

  categorySlug: string;

  subCategoryName: string;

  subCategorySlug: string;

  location: string;

  cityName: string;

  citySlug: string;

  countryName: string;

  countrySlug: string;

  deliveryDescription: string;

  seatingDescription: string;

  hospitalityDescription: string;

  meetingPoint: any;

  freeCancellation: boolean;

  cancellationPolicy: any;

  thinksToKnow: string[];

  warrantyContent: string[];

  minPax: number;

  maxPax: number;

  totalAmount: number;

  totalPrice: number;

  totalPax: TotalPax[];

  currency: string;

  wholesaleCode: number;

  keySearchTimeExpire: number;

  expired: string;

  instantConfirm: boolean;

  constructor(res: any) {
    super(res);
    this.name = res.name || "";
    this.image = res.image || "";
    this.date = res.date || "";
    this.time = res.time || "";
    this.eventId = res.eventId || "";
    this.eventName = res.eventName || "";
    this.eventSlug = res.eventSlug || "";
    this.categoryName = res.categoryName || "";
    this.categorySlug = res.categorySlug || "";
    this.subCategoryName = res.subCategoryName || "";
    this.subCategorySlug = res.subCategorySlug || "";
    this.location = res.location || "";
    this.cityName = res.cityName || "";
    this.citySlug = res.citySlug || "";
    this.countryName = res.countryName || "";
    this.countrySlug = res.countrySlug || "";
    this.deliveryDescription = res.deliveryDescription || "";
    this.seatingDescription = res.seatingDescription || "";
    this.hospitalityDescription = res.hospitalityDescription || "";
    this.meetingPoint = res.meetingPoint || null;
    this.freeCancellation = res.freeCancellation || false;
    this.cancellationPolicy = res.cancellationPolicy || null;
    this.thinksToKnow = res.thinksToKnow || [];
    this.warrantyContent = res.warrantyContent || [];
    this.minPax = res.minPax || 0;
    this.maxPax = res.maxPax || 0;
    this.totalAmount = res.totalAmount || 0;
    this.totalPrice = res.totalPrice || 0;
    this.totalPax = res.totalPax || [];
    this.currency = res.currency || "";
    this.wholesaleCode = res.wholesaleCode || 0;
    this.keySearchTimeExpire = res.keySearchTimeExpire || 0;
    this.expired = res.expired || "";
    this.instantConfirm = res.instantConfirm || false;
  }
}
export interface TotalPax {
  type: string;
  amount: number;
}

export class EventPreAllocateData {
  status: boolean;

  message: string;

  data: EventPreAllocateDataInterface;

  constructor(response: EventPreAllocateData) {
    this.status = response?.status || false;
    this.message = response?.message || "";
    this.data = new EventPreAllocateDataPresenter(response.data);
  }
}
